import { connect } from 'react-redux'
import PropiedadesList from '../../../../components/Sections/Propiedades/PropiedadesList/List'

const mapStateToProps = (state) => {
  return {
    properties: state.propiedades.list,
    loading: state.propiedades.loading
  }
}

export default connect(
  mapStateToProps
)(PropiedadesList)



// WEBPACK FOOTER //
// ./src/containers/Sections/Propiedades/List/list.js